
import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import { onBeforeUnmount, ref, shallowRef, onMounted } from "vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { IEditorConfig } from "@wangeditor/editor";
import { Toast } from "@/utils";
import { useStore } from "vuex";
import { putObject } from "@/utils/base/cos";



export default {
  components: { Editor, Toolbar },
  setup(props, context) {
    const store = useStore();
    // 菜单配置
    const editorConfig: Partial<IEditorConfig> = {
      MENU_CONF: {},
      // 其他属性...
    };

    const baseUploadConfig = {
      // 上传进度的回调函数
      onProgress(progress: number) {
        store.commit("SET_LOADING_STATUS", {
          status: true,
          msg: `上传中 ${progress}%`,
        });
      },
      onSuccess(file: File, res: any) {
        context.emit("uploadlFile", res.data.url);
        store.commit("SET_LOADING_STATUS", { status: false });
        Toast("success", `${file.name} 上传成功`, 3);
      },
      onFailed(file: File, res: any) {
        store.commit("SET_LOADING_STATUS", { status: false });
        Toast("error", `${file.name} 上传失败`, 3);
      },
      onError(file: File, err: any, res: any) {
        store.commit("SET_LOADING_STATUS", { status: false });
        Toast("error", `${file.name} 上传出错`, 3);
      },
    };

    const customUpload = async (res, insertFn) => {
      const suffix = res.name.split(".").slice(-1)[0];
      putObject(
        {
          Body: res,
          Key: `file/ProductInfo/${new Date().getTime()}.${suffix}`,
        },
        (e) => {
          if (["jpg", "png"].includes(suffix)) return;
          const percent = ((e.loaded / e.total) * 100).toFixed(2);
          store.commit("SET_LOADING_STATUS", {
            status: true,
            msg: `${percent}%`,
          });
        }
      )
        .then((res) => {
          insertFn(res.fileAddress);
          Toast("success", `上传成功`, 3);
          store.commit("SET_LOADING_STATUS", {
            status: false,
            msg: "",
          });
        })
        .catch((err) => {
          Toast("error", `上传出错`, 3);
          store.commit("SET_LOADING_STATUS", {
            status: false,
            msg: "",
          });
        });
    };

    const uploadConfig = {
      server: "/api-qc/uploadProductInfo",
      fieldName: "file",
    };

    editorConfig.MENU_CONF["uploadImage"] = {
      //   ...uploadConfig,
      customUpload,
      maxFileSize: 5 * 1024 * 1024,
      timeout: 60 * 1000,
      // 上传之前触发
      onBeforeUpload(file: File) {
        console.log(file, "++++++++++++++");
        return file;
      },
      //   ...baseUploadConfig,
    };

    editorConfig.MENU_CONF["uploadVideo"] = {
      //   ...uploadConfig,
      customUpload,
      maxFileSize: 200 * 1024 * 1024,
      timeout: 10 * 60 * 1000,
      // 上传之前触发
      onBeforeUpload(file: File) {
        console.log(file, "++++++++++++++");
        return file;
      },
      //   ...baseUploadConfig,
    };

    // 编辑器实例，必须用 shallowRef
    const editorRef = shallowRef();

    // 内容 HTML
    const valueHtml = ref("");

    const toolbarConfig = {};
    // const editorConfig = { placeholder: '请输入内容...' }

    // 组件销毁时，也及时销毁编辑器
    onBeforeUnmount(() => {
      const editor = editorRef.value;
      if (editor == null) return;
      editor.destroy();
    });

    const handleCreated = (editor) => {
      editorRef.value = editor; // 记录 editor 实例，重要！
    };

    const setValue = (valuehtml) => {
      valueHtml.value = valuehtml;
    };

    return {
      editorRef,
      valueHtml,
      mode: "default", // 或 'simple'
      toolbarConfig,
      editorConfig,
      handleCreated,
      setValue,
    };
  },
};
